/* eslint-disable consistent-return */
/* eslint-disable react/no-children-prop */
import React, { useState } from 'react';
import { Container, CssBaseline, Grid } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../assets/styles/pages/Fidelity';

import Header from '../../../components/Header';
import FooterMenuMain from '../../../components/FooterMenuMain';
import TitlePage from '../../../components/TitlePage';
import OptionMenu from '../../../components/OptionMenu';

import { ReactComponent as IconFidelidadeActive } from '../../../assets/images/svg/menu_main/icon_fidelidade_active.svg';
import { ReactComponent as IconCashBack } from '../../../assets/images/svg/user/cashback.svg';
import { ReactComponent as IconGrupoWhatsApp } from '../../../assets/images/svg/user/grupo_whats.svg';
import { ReactComponent as IconWinningRegister } from '../../../assets/images/svg/user/icon_cadastro_premiado.svg';
import { ReactComponent as IconAwardedOrder } from '../../../assets/images/svg/utils/pedido_premiado.svg';
import { ReactComponent as IconIndicationUser } from '../../../assets/images/svg/sign_up/indique_ganhe.svg';
import { ReactComponent as IconCartera } from '../../../assets/images/svg/shops/icon_carteora.svg';
import { getStorege } from '../../../helpers/db_storage';
import { api } from '../../../services';
import { ItypeReturnApi } from '../../../helpers/utils/TypeReturnApi';
import ModalConfirmFooter from '../../../components/Modal/ConfirmFooter';

const Fidelity: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const [openModalNotice, setOpenModalNotice] = useState(false);
  const [msgnModalNotice, setMsgModalNotice] = useState({
    title: 'Atenção',
    messagem: '',
  });
  const handleToPage = (url: string, replace = false): void => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (!dataUserStorage?.idUsuario) {
      setOpenModalNotice(true);
      setMsgModalNotice({
        title: 'Atenção',
        messagem:
          'É necessário efetuar login ou criar a conta antes de acessar o programa de recompensa.',
      });
      return;
    }

    if (replace) {
      return navigate(url, { replace: true });
    }
    return navigate(url);
  };

  const handleToLink = (url: string): void => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
  };

  const handleGetUrlGroupWhatsApp = async (): Promise<void> => {
    try {
      const dataStorage = JSON.parse(
        localStorage.getItem('@mais/delivery/dataStateCity') as string,
      );

      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.getDataUser(
        {
          nr_operacao: 74,
          idMarketplace: dataStorage?.idMarketplace,
        },
      );

      if (!result.data[0]?.dsGrupoWhatsApp) {
        setOpenModalNotice(true);
        setMsgModalNotice({
          title: 'Atenção',
          messagem:
            'Infelizmente sua cidade ainda não tem um grupo formado. Tente novamente mais tarde.',
        });
        return;
      }

      handleToLink(result.data[0].dsGrupoWhatsApp);
    } catch (error) {
      toast.error('Não foi possível acessa grupo.');
    }
  };

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="fidelity" />
      <CssBaseline />
      <Grid marginBottom="100px">
        <TitlePage
          Icon={IconFidelidadeActive}
          title="Programas de Fidelidade"
        />
        <Grid marginTop={2}>
          <OptionMenu
            Icon={IconCashBack}
            title="CashBack"
            fn={() => handleToPage('/fidelity/cashback')}
          />
          <OptionMenu
            Icon={IconIndicationUser}
            title="Indique e Ganhe"
            fn={() => handleToPage('/fidelity/indicatewin')}
          />
          <OptionMenu
            Icon={IconAwardedOrder}
            title="Pedido Premiado"
            fn={() => handleToPage('/fidelity/awardedorder')}
          />
          <OptionMenu
            Icon={IconWinningRegister}
            title="Cadastro Premiado"
            fn={() => handleToPage('/fidelity/winningregister')}
          />
          <OptionMenu
            Icon={IconGrupoWhatsApp}
            title="Grupo com cupons e promoções exclusívas"
            fn={handleGetUrlGroupWhatsApp}
          />
          <OptionMenu
            Icon={IconCartera}
            title="Extrato da Conta"
            fn={() => handleToPage('/fidelity/extract')}
          />
        </Grid>
      </Grid>
      <FooterMenuMain children="fidelity" />
      <ModalConfirmFooter
        isOpen={openModalNotice}
        title={msgnModalNotice.title}
        message={msgnModalNotice.messagem}
        btnNamePrimary="Ok"
        btnNameSecondary=""
        btnCancel=""
        handleFn={async () => setOpenModalNotice(false)}
        onClose={() => setOpenModalNotice(false)}
        heightModal="400px"
      />
    </Container>
  );
};

export default Fidelity;
